// extracted by mini-css-extract-plugin
module.exports = {"smallLoader":"SmallLoader_smallLoader__SrnWI","rotate":"SmallLoader_rotate__UIhAQ"};